import { useDispatch } from "react-redux";
import Button from "../../sharedComponents/buttons/button";
import { deleteLookup } from "./../../../API/services/utilities";

const DeleteLookup = ({ modalVisible, setModalVisible, selectedLookup }) => {
  const dispatch = useDispatch();

  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" />
      <div className="my-2">تاكيد حذف مجموعة العمل</div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={"نعم"}
          buttonStyleType="solid"
          onClick={async () => {
            let res = await deleteLookup(
              modalVisible.helperData?.id,
              selectedLookup
            );
            if (res?.status <= 206) {
              dispatch({ type: "RELOAD" });
              setModalVisible({
                ...modalVisible,
                deleteLookup: false,
                helperData: null,
              });
            }
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={"لا"}
          onClick={() => {
            setModalVisible({
              ...modalVisible,
              deleteLookup: false,
              helperData: null,
            });
          }}
        />
      </div>
    </div>
  );
};

export default DeleteLookup;
